export interface FileExporter {
  exportFile: (fileName: string) => Promise<void>;
}
